import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/API';
import type { ResourceActivity } from '@/types/resourceActivity';

const fetchSiteActivities = async (
  siteId: string
): Promise<ResourceActivity[]> => {
  const response = await API.authenticated.fetch(
    `/sites/${siteId}/activities`
  );

  if (!response.ok) {
    throw new Error('Failed to fetch site activities');
  }

  return response.json();
};

export const useSiteActivities = (siteId: string | null) => {
  const {
    data: activities = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['site-activities', siteId],
    queryFn: () => fetchSiteActivities(siteId!),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    activities,
    isLoading,
    error: error ? (error as Error).message : null,
    refetch,
  };
};
